import router from '@/router'
import store from '@/store'
import { format, subDays, parse, isValid } from 'date-fns'
import config from '@/helpers/config'
import { getQueryFromDateTime } from '@/helpers/formatters'

const state = {
  dirty: false,
  projectUuid: '',
  fromDate: format(subDays(new Date(), 0), config.defaultDateFormat),
  toDate: format(subDays(new Date(), 0), config.defaultDateFormat),
  fromTime: [],
  toTime: [],
  isDetected: true,
  countryId: [],
  stateId: [],
  cityId: [],
  userId: [],
  hashtag: [],
  emoji: [],
  domain: [],
  tweetType: [],
  sentiment: [],
  entity: [],
  entityType: [],
  topic: [],
  articleTopic: [],
  tweetTopic: [],
  screenName: [],
  text: [],
  excludeTerm: [],
  languageId: []
}

const mutations = {
  setProjectUuidFilter (state, payload) {
    state.projectUuid = payload
    router.push({ query: Object.assign({}, router.currentRoute.query, { projectUuid: state.projectUuid }) })
  },
  resetProjectUuidFilter (state) {
    state.projectUuid = store.getters['auth/currentUser'].projects[0].uuid
    router.push({ query: Object.assign({}, router.currentRoute.query, { projectUuid: state.projectUuid }) })
  },
  setFromDateFilter (state, payload) {
    if (isValid(parse(payload))) {
      state.fromDate = payload
    } else {
      state.fromDate = format(subDays(new Date(), 0), config.defaultDateFormat)
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { fromDate: state.fromDate }) })
  },
  resetFromDateFilter (state) {
    state.fromDate = format(subDays(new Date(), 0), config.defaultDateFormat)
    router.push({ query: Object.assign({}, router.currentRoute.query, { fromDate: state.fromDate }) })
  },
  setToDateFilter (state, payload) {
    if (isValid(parse(payload))) {
      state.toDate = payload
    } else {
      state.toDate = format(subDays(new Date(), 0), config.defaultDateFormat)
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { toDate: state.toDate }) })
  },
  resetToDateFilter (state) {
    state.toDate = format(subDays(new Date(), 0), config.defaultDateFormat)
    router.push({ query: Object.assign({}, router.currentRoute.query, { toDate: state.toDate }) })
  },
  setFromTimeFilter (state, payload) {
    state.fromTime = (payload)
    router.push({ query: Object.assign({}, router.currentRoute.query, { fromTime: state.fromTime }) })
  },
  resetFromTimeFilter (state) {
    state.fromTime = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { fromTime: state.fromTime }) })
  },
  setToTimeFilter (state, payload) {
    state.toTime = (payload)
    router.push({ query: Object.assign({}, router.currentRoute.query, { toTime: state.toTime }) })
  },
  resetToTimeFilter (state) {
    state.toTime = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { toTime: state.toTime }) })
  },
  setIsDetectedFilter (state, payload) {
    if (typeof (payload) === typeof (true)) {
      state.isDetected = payload
    } else {
      state.isDetected = (payload === 'true')
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { isDetected: state.isDetected }) })
  },
  resetIsDetectedFilter (state) {
    state.isDetected = true
    router.push({ query: Object.assign({}, router.currentRoute.query, { isDetected: state.isDetected }) })
  },
  setCountryIdFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.countryId = payload.map(Number).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.countryId = [Number(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { countryId: state.countryId }) })
  },
  resetCountryIdFilter (state) {
    state.countryId = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { countryId: state.countryId }) })
  },
  setStateIdFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.stateId = payload.map(Number).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.stateId = [Number(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { stateId: state.stateId }) })
  },
  resetStateIdFilter (state) {
    state.stateId = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { stateId: state.stateId }) })
  },
  setCityIdFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.cityId = payload.map(Number).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.cityId = [Number(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { cityId: state.cityId }) })
  },
  resetCityIdFilter (state) {
    state.cityId = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { cityId: state.cityId }) })
  },
  setUserIdFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.userId = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.userId = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { userId: state.userId }) })
  },
  resetUserIdFilter (state) {
    state.userId = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { userId: state.userId }) })
  },
  setHashtagFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.hashtag = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.hashtag = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { hashtag: state.hashtag }) })
  },
  resetHashtagFilter (state) {
    state.hashtag = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { hashtag: state.hashtag }) })
  },
  setEmojiFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.emoji = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.emoji = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { emoji: state.emoji }) })
  },
  resetEmojiFilter (state) {
    state.emoji = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { emoji: state.emoji }) })
  },
  setTweetTypeFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.tweetType = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.tweetType = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { tweetType: state.tweetType }) })
  },
  resetTweetTypeFilter (state) {
    state.tweetType = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { tweetType: state.tweetType }) })
  },
  setSentimentFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.sentiment = payload.map(Number).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.sentiment = [Number(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { sentiment: state.sentiment }) })
  },
  resetSentimentFilter (state) {
    state.sentiment = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { sentiment: state.sentiment }) })
  },
  setEntityFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.entity = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.entity = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { entity: state.entity }) })
  },
  resetEntityFilter (state) {
    state.entity = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { entity: state.entity }) })
  },
  setEntityTypeFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.entityType = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.entityType = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { entityType: state.entityType }) })
  },
  resetEntityTypeFilter (state) {
    state.entityType = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { entityType: state.entityType }) })
  },
  setTopicFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.topic = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.topic = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { topic: state.topic }) })
  },
  resetTopicFilter (state) {
    state.topic = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { topic: state.topic }) })
  },
  setArticleTopicFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.articleTopic = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.articleTopic = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { articleTopic: state.articleTopic }) })
  },
  resetArticleTopicFilter (state) {
    state.articleTopic = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { articleTopic: state.articleTopic }) })
  },
  setTweetTopicFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.tweetTopic = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.tweetTopic = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { tweetTopic: state.tweetTopic }) })
  },
  resetTweetTopicFilter (state) {
    state.tweetTopic = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { tweetTopic: state.tweetTopic }) })
  },
  setScreenNameFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.screenName = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.screenName = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { screenName: state.screenName }) })
  },
  resetScreenNameFilter (state) {
    state.screenName = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { screenName: state.screenName }) })
  },
  setTextFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.text = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.text = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { text: state.text }) })
  },
  resetTextFilter (state) {
    state.text = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { text: state.text }) })
  },
  setExcludeTermFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.excludeTerm = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.excludeTerm = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { excludeTerm: state.excludeTerm }) })
  },
  resetExcludeTermFilter (state) {
    state.excludeTerm = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { excludeTerm: state.excludeTerm }) })
  },
  setDomainFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.domain = payload.map(String).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.domain = [String(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { domain: state.domain }) })
  },
  resetDomainFilter (state) {
    state.domain = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { domain: state.domain }) })
  },
  setLanguageIdFilter (state, payload) {
    if (Array.isArray(payload)) {
      state.languageId = payload.map(Number).filter(function (item, pos, self) {
        return self.indexOf(item) === pos
      })
    } else {
      state.languageId = [Number(payload)]
    }
    router.push({ query: Object.assign({}, router.currentRoute.query, { languageId: state.languageId }) })
  },
  resetLanguageIdFilter (state) {
    state.languageId = []
    router.push({ query: Object.assign({}, router.currentRoute.query, { languageId: state.languageId }) })
  },
  setCustomFilters (state, payload) {
    if (Object.keys(payload) && Object.keys(payload).length !== 0) {
      for (var item in payload) {
        if (item === 'projectUuid') {
          var project = store.getters['auth/currentUser'].projects.find(function (p) { return p.uuid === payload.projectUuid })
          if (project) {
            store.commit('filters/setProjectUuidFilter', project.uuid)
          } else {
            router.push('/login')
          }
        }
        if (item === 'fromDate') {
          store.commit('filters/setFromDateFilter', payload.fromDate)
        }
        if (item === 'toDate') {
          store.commit('filters/setToDateFilter', payload.toDate)
        }
        if (item === 'fromTime') {
          store.commit('filters/setFromTimeFilter', payload.fromTime)
        }
        if (item === 'toTime') {
          store.commit('filters/setToTimeFilter', payload.toTime)
        }
        if (item === 'isDetected') {
          store.commit('filters/setIsDetectedFilter', payload.isDetected)
        }
        if (item === 'countryId') {
          store.commit('filters/setCountryIdFilter', payload.countryId)
        }
        if (item === 'stateId') {
          store.commit('filters/setStateIdFilter', payload.stateId)
        }
        if (item === 'cityId') {
          store.commit('filters/setCityIdFilter', payload.cityId)
        }
        if (item === 'userId') {
          store.commit('filters/setUserIdFilter', payload.userId)
        }
        if (item === 'hashtag') {
          store.commit('filters/setHashtagFilter', payload.hashtag)
        }
        if (item === 'emoji') {
          store.commit('filters/setEmojiFilter', payload.emoji)
        }
        if (item === 'tweetType') {
          store.commit('filters/setTweetTypeFilter', payload.tweetType)
        }
        if (item === 'sentiment') {
          store.commit('filters/setSentimentFilter', payload.sentiment)
        }
        if (item === 'entity') {
          store.commit('filters/setEntityFilter', payload.entity)
        }
        if (item === 'entityType') {
          store.commit('filters/setEntityTypeFilter', payload.entityType)
        }
        if (item === 'topic') {
          store.commit('filters/setTopicFilter', payload.topic)
        }
        if (item === 'articleTopic') {
          store.commit('filters/setArticleTopicFilter', payload.articleTopic)
        }
        if (item === 'tweetTopic') {
          store.commit('filters/setTweetTopicFilter', payload.tweetTopic)
        }
        if (item === 'screenName') {
          store.commit('filters/setScreenNameFilter', payload.screenName)
        }
        if (item === 'text') {
          store.commit('filters/setTextFilter', payload.text)
        }
        if (item === 'excludeTerm') {
          store.commit('filters/setExcludeTermFilter', payload.excludeTerm)
        }
        if (item === 'domain') {
          store.commit('filters/setDomainFilter', payload.domain)
        }
        if (item === 'languageId') {
          store.commit('filters/setLanguageIdFilter', payload.languageId)
        }
      }
    }
  },
  setAllFilters (state, payload) {
    if (Object.keys(payload) && Object.keys(payload).length !== 0) {
      for (var item in payload) {
        if (item === 'projectUuid') {
          var project = store.getters['auth/currentUser'].projects.find(function (p) { return p.uuid === payload.projectUuid })
          if (project) {
            store.commit('filters/setProjectUuidFilter', project.uuid)
          } else {
            store.dispatch('auth/logout', { ...this.$data })
            router.push('/login')
          }
        }
        if (item === 'fromDate') {
          store.commit('filters/setFromDateFilter', payload.fromDate)
        }
        if (item === 'toDate') {
          store.commit('filters/setToDateFilter', payload.toDate)
        }
        if (item === 'fromTime') {
          store.commit('filters/setFromTimeFilter', payload.fromTime)
        }
        if (item === 'toTime') {
          store.commit('filters/setToTimeFilter', payload.toTime)
        }
        if (item === 'isDetected') {
          store.commit('filters/setIsDetectedFilter', payload.isDetected)
        }
        if (item === 'countryId') {
          store.commit('filters/setCountryIdFilter', payload.countryId)
        }
        if (item === 'stateId') {
          store.commit('filters/setStateIdFilter', payload.stateId)
        }
        if (item === 'cityId') {
          store.commit('filters/setCityIdFilter', payload.cityId)
        }
        if (item === 'userId') {
          store.commit('filters/setUserIdFilter', payload.userId)
        }
        if (item === 'hashtag') {
          store.commit('filters/setHashtagFilter', payload.hashtag)
        }
        if (item === 'emoji') {
          store.commit('filters/setEmojiFilter', payload.emoji)
        }
        if (item === 'tweetType') {
          store.commit('filters/setTweetTypeFilter', payload.tweetType)
        }
        if (item === 'sentiment') {
          store.commit('filters/setSentimentFilter', payload.sentiment)
        }
        if (item === 'entity') {
          store.commit('filters/setEntityFilter', payload.entity)
        }
        if (item === 'entityType') {
          store.commit('filters/setEntityTypeFilter', payload.entityType)
        }
        if (item === 'topic') {
          store.commit('filters/setTopicFilter', payload.topic)
        }
        if (item === 'articleTopic') {
          store.commit('filters/setArticleTopicFilter', payload.articleTopic)
        }
        if (item === 'tweetTopic') {
          store.commit('filters/setTweetTopicFilter', payload.tweetTopic)
        }
        if (item === 'screenName') {
          store.commit('filters/setScreenNameFilter', payload.screenName)
        }
        if (item === 'text') {
          store.commit('filters/setTextFilter', payload.text)
        }
        if (item === 'excludeTerm') {
          store.commit('filters/setExcludeTermFilter', payload.excludeTerm)
        }
        if (item === 'domain') {
          store.commit('filters/setDomainFilter', payload.domain)
        }
        if (item === 'languageId') {
          store.commit('filters/setLanguageIdFilter', payload.languageId)
        }
      }
    }

    if (!('projectUuid' in payload) || store.getters['filters/getProjectUuid'] === '') {
      store.commit('filters/resetProjectUuidFilter')
    }

    if (!('fromDate' in payload)) {
      store.commit('filters/resetFromDateFilter')
    }

    if (!('toDate' in payload)) {
      store.commit('filters/resetToDateFilter')
    }

    if (!('fromTime' in payload)) {
      store.commit('filters/resetFromTimeFilter')
    }

    if (!('toTime' in payload)) {
      store.commit('filters/resetToTimeFilter')
    }

    if (!('isDetected' in payload)) {
      store.commit('filters/resetIsDetectedFilter')
    }

    if (!('countryId' in payload)) {
      store.commit('filters/resetCountryIdFilter')
    }

    if (!('stateId' in payload)) {
      store.commit('filters/resetStateIdFilter')
    }

    if (!('cityId' in payload)) {
      store.commit('filters/resetCityIdFilter')
    }

    if (!('userId' in payload)) {
      store.commit('filters/resetUserIdFilter')
    }

    if (!('hashtag' in payload)) {
      store.commit('filters/resetHashtagFilter')
    }

    if (!('emoji' in payload)) {
      store.commit('filters/resetEmojiFilter')
    }

    if (!('tweetType' in payload)) {
      store.commit('filters/resetTweetTypeFilter')
    }

    if (!('sentiment' in payload)) {
      store.commit('filters/resetSentimentFilter')
    }

    if (!('entity' in payload)) {
      store.commit('filters/resetEntityFilter')
    }

    if (!('entityType' in payload)) {
      store.commit('filters/resetEntityTypeFilter')
    }

    if (!('topic' in payload)) {
      store.commit('filters/resetTopicFilter')
    }

    if (!('articleTopic' in payload)) {
      store.commit('filters/resetArticleTopicFilter')
    }

    if (!('tweetTopic' in payload)) {
      store.commit('filters/resetTweetTopicFilter')
    }

    if (!('screenName' in payload)) {
      store.commit('filters/resetScreenNameFilter')
    }

    if (!('text' in payload)) {
      store.commit('filters/resetTextFilter')
    }

    if (!('excludeTerm' in payload)) {
      store.commit('filters/resetExcludeTermFilter')
    }

    if (!('domain' in payload)) {
      store.commit('filters/resetDomainFilter')
    }

    if (!('languageId' in payload)) {
      store.commit('filters/resetLanguageIdFilter')
    }
  },
  resetCustomFilters (state, payload) {
    if (Object.keys(payload) && Object.keys(payload).length !== 0) {
      for (var item in payload) {
        if (item === 'fromDate') {
          store.commit('filters/resetFromDateFilter')
        }
        if (item === 'toDate') {
          store.commit('filters/resetToDateFilter')
        }
        if (item === 'fromTime') {
          store.commit('filters/resetFromTimeFilter')
        }
        if (item === 'toTime') {
          store.commit('filters/resetToTimeFilter')
        }
        if (item === 'isDetected') {
          store.commit('filters/resetIsDetectedFilter')
        }
        if (item === 'countryId') {
          store.commit('filters/resetCountryIdFilter')
        }
        if (item === 'stateId') {
          store.commit('filters/resetStateIdFilter')
        }
        if (item === 'cityId') {
          store.commit('filters/resetCityIdFilter')
        }
        if (item === 'userId') {
          store.commit('filters/resetUserIdFilter')
        }
        if (item === 'hashtag') {
          store.commit('filters/resetHashtagFilter')
        }
        if (item === 'emoji') {
          store.commit('filters/resetEmojiFilter')
        }
        if (item === 'tweetType') {
          store.commit('filters/resetTweetTypeFilter')
        }
        if (item === 'sentiment') {
          store.commit('filters/resetSentimentFilter')
        }
        if (item === 'entity') {
          store.commit('filters/resetEntityFilter')
        }
        if (item === 'entityType') {
          store.commit('filters/resetEntityTypeFilter')
        }
        if (item === 'topic') {
          store.commit('filters/resetTopicFilter')
        }
        if (item === 'articleTopic') {
          store.commit('filters/resetArticleTopicFilter')
        }
        if (item === 'tweetTopic') {
          store.commit('filters/resetTweetTopicFilter')
        }
        if (item === 'screenName') {
          store.commit('filters/resetScreenNameFilter')
        }
        if (item === 'text') {
          store.commit('filters/resetTextFilter')
        }
        if (item === 'excludeTerm') {
          store.commit('filters/resetExcludeTermFilter')
        }
        if (item === 'domain') {
          store.commit('filters/resetDomainFilter')
        }
        if (item === 'languageId') {
          store.commit('filters/resetLanguageIdFilter')
        }
      }
    }
  },
  resetAllFilters (state) {
    store.commit('filters/resetFromTimeFilter')
    store.commit('filters/resetToTimeFilter')
    store.commit('filters/resetIsDetectedFilter')
    store.commit('filters/resetCountryIdFilter')
    store.commit('filters/resetStateIdFilter')
    store.commit('filters/resetCityIdFilter')
    store.commit('filters/resetUserIdFilter')
    store.commit('filters/resetHashtagFilter')
    store.commit('filters/resetEmojiFilter')
    store.commit('filters/resetTweetTypeFilter')
    store.commit('filters/resetSentimentFilter')
    store.commit('filters/resetEntityFilter')
    store.commit('filters/resetEntityTypeFilter')
    store.commit('filters/resetTopicFilter')
    store.commit('filters/resetArticleTopicFilter')
    store.commit('filters/resetTweetTopicFilter')
    store.commit('filters/resetScreenNameFilter')
    store.commit('filters/resetTextFilter')
    store.commit('filters/resetExcludeTermFilter')
    store.commit('filters/resetDomainFilter')
    store.commit('filters/resetLanguageIdFilter')
  },
  setDirty (state, payload) {
    state.dirty = Boolean(payload)
  },
  resetDirty (state) {
    state.dirty = false
  },
  setProjectUuid (state, payload) {
    state.projectUuid = payload
  },
  setFromDate (state, payload) {
    state.fromDate = payload
  },
  setToDate (state, payload) {
    state.toDate = payload
  },
  setFromTime (state, payload) {
    state.fromTime = payload
  },
  setToTime (state, payload) {
    state.toTime = payload
  },
  setIsDetected (state, payload) {
    state.isDetected = payload
  },
  setCountryId (state, payload) {
    state.countryIds = payload
  },
  setStateId (state, payload) {
    state.stateId = payload
  },
  setCityId (state, payload) {
    state.cityId = payload
  },
  setUserId (state, payload) {
    state.userId = payload
  },
  setHashtag (state, payload) {
    state.hashtag = payload
  },
  setEmoji (state, payload) {
    state.emoji = payload
  },
  setTweetType (state, payload) {
    state.tweetType = payload
  },
  setSentiment (state, payload) {
    state.sentiment = payload
  },
  setEntity (state, payload) {
    state.entity = payload
  },
  setEntityType (state, payload) {
    state.entityType = payload
  },
  setTopic (state, payload) {
    state.topic = payload
  },
  setArticleTopic (state, payload) {
    state.articleTopic = payload
  },
  setTweetTopic (state, payload) {
    state.tweetTopic = payload
  },
  setScreenName (state, payload) {
    state.screenName = payload
  },
  setText (state, payload) {
    state.text = payload
  },
  setExcludeTerm (state, payload) {
    state.excludeTerm = payload
  },
  setDomain (state, payload) {
    state.domain = payload
  },
  setLanguageId (state, payload) {
    state.languageId = payload
  }
}

const actions = {}

const getters = {
  getFilters (state) {
    return {
      dirty: state.dirty,
      projectUuid: state.projectUuid,
      fromDate: state.fromDate,
      toDate: state.toDate,
      fromTime: state.fromTime,
      toTime: state.toTime,
      isDetected: state.isDetected,
      countryId: state.countryId,
      stateId: state.stateId,
      cityId: state.cityId,
      userId: state.userId,
      domain: state.domain,
      tweetType: state.tweetType,
      sentiment: state.sentiment,
      entity: state.entity,
      entityType: state.entityType,
      topic: state.topic,
      articleTopic: state.articleTopic,
      tweetTopic: state.tweetTopic,
      screenName: state.screenName,
      text: state.text,
      excludeTerm: state.excludeTerm,
      languageId: state.languageId,
      hashtag: state.hashtag,
      emoji: state.emoji}
  },
  getCustomQuery: state => extra => {
    let q = '?'
    let params = []
    Object.entries(extra).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        for (var i = 0; i < value.length; i++) {
          params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value[i]))
        }
      } else {
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))
      }
    })
    params.push(encodeURIComponent('no_cache') + '=' + encodeURIComponent((new Date()).getTime()))
    return q + params.join('&')
  },
  getQuery: state => extra => {
    let i = 0
    let q = '?'
    let params = []

    if (state.projectUuid && state.projectUuid.length > 0) {
      params.push(encodeURIComponent('projectUuid') + '=' + encodeURIComponent(state.projectUuid))
    }

    if (state.fromDate && isValid(parse(state.fromDate))) {
      if (!Array.isArray(state.fromTime)) {
        var fromTimeArray = state.fromTime.split(':')
        params.push(encodeURIComponent('fromDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.fromDate, fromTimeArray[0], fromTimeArray[1], fromTimeArray[2])))
      } else {
        params.push(encodeURIComponent('fromDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.fromDate, 0, 0, 0)))
      }
    }

    if (state.toDate && isValid(parse(state.toDate))) {
      if (!Array.isArray(state.toTime)) {
        var toTimeArray = state.toTime.split(':')
        params.push(encodeURIComponent('toDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.toDate, toTimeArray[0], toTimeArray[1], toTimeArray[2])))
      } else {
        params.push(encodeURIComponent('toDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.toDate, 23, 59, 59)))
      }
    }

    params.push(encodeURIComponent('isDetected') + '=' + encodeURIComponent(state.isDetected))

    if (state.countryId && state.countryId.length > 0) {
      for (i = 0; i < state.countryId.length; i++) {
        params.push(encodeURIComponent('countryId') + '=' + encodeURIComponent(state.countryId[i]))
      }
    }

    if (state.stateId && state.stateId.length > 0) {
      for (i = 0; i < state.stateId.length; i++) {
        params.push(encodeURIComponent('stateId') + '=' + encodeURIComponent(state.stateId[i]))
      }
    }

    if (state.cityId && state.cityId.length > 0) {
      for (i = 0; i < state.cityId.length; i++) {
        params.push(encodeURIComponent('cityId') + '=' + encodeURIComponent(state.cityId[i]))
      }
    }

    if (state.userId && state.userId.length > 0) {
      for (i = 0; i < state.userId.length; i++) {
        params.push(encodeURIComponent('userId') + '=' + encodeURIComponent(state.userId[i]))
      }
    }

    if (state.hashtag && state.hashtag.length > 0) {
      for (i = 0; i < state.hashtag.length; i++) {
        params.push(encodeURIComponent('hashtag') + '=' + encodeURIComponent(state.hashtag[i]))
      }
    }

    if (state.emoji && state.emoji.length > 0) {
      for (i = 0; i < state.emoji.length; i++) {
        params.push(encodeURIComponent('emoji') + '=' + encodeURIComponent(state.emoji[i]))
      }
    }

    if (state.tweetType && state.tweetType.length > 0) {
      for (i = 0; i < state.tweetType.length; i++) {
        params.push(encodeURIComponent('tweetType') + '=' + encodeURIComponent(state.tweetType[i]))
      }
    }

    if (state.sentiment && state.sentiment.length > 0) {
      for (i = 0; i < state.sentiment.length; i++) {
        params.push(encodeURIComponent('sentiment') + '=' + encodeURIComponent(state.sentiment[i]))
      }
    }

    if (state.entity && state.entity.length > 0) {
      for (i = 0; i < state.entity.length; i++) {
        params.push(encodeURIComponent('entity') + '=' + encodeURIComponent(state.entity[i]))
      }
    }

    if (state.entityType && state.entityType.length > 0) {
      for (i = 0; i < state.entityType.length; i++) {
        params.push(encodeURIComponent('entityType') + '=' + encodeURIComponent(state.entityType[i]))
      }
    }

    if (state.topic && state.topic.length > 0) {
      for (i = 0; i < state.topic.length; i++) {
        params.push(encodeURIComponent('topic') + '=' + encodeURIComponent(state.topic[i]))
      }
    }

    if (state.articleTopic && state.articleTopic.length > 0) {
      for (i = 0; i < state.articleTopic.length; i++) {
        params.push(encodeURIComponent('articleTopic') + '=' + encodeURIComponent(state.articleTopic[i]))
      }
    }

    if (state.tweetTopic && state.tweetTopic.length > 0) {
      for (i = 0; i < state.tweetTopic.length; i++) {
        params.push(encodeURIComponent('tweetTopic') + '=' + encodeURIComponent(state.tweetTopic[i]))
      }
    }

    if (state.screenName && state.screenName.length > 0) {
      for (i = 0; i < state.screenName.length; i++) {
        params.push(encodeURIComponent('screenName') + '=' + encodeURIComponent(state.screenName[i]))
      }
    }

    if (state.text && state.text.length > 0) {
      for (i = 0; i < state.text.length; i++) {
        params.push(encodeURIComponent('text') + '=' + encodeURIComponent(state.text[i]))
      }
    }

    if (state.excludeTerm && state.excludeTerm.length > 0) {
      for (i = 0; i < state.excludeTerm.length; i++) {
        params.push(encodeURIComponent('excludeTerm') + '=' + encodeURIComponent(state.excludeTerm[i]))
      }
    }

    if (state.domain && state.domain.length > 0) {
      for (i = 0; i < state.domain.length; i++) {
        params.push(encodeURIComponent('domain') + '=' + encodeURIComponent(state.domain[i]))
      }
    }

    if (state.languageId && state.languageId.length > 0) {
      for (i = 0; i < state.languageId.length; i++) {
        params.push(encodeURIComponent('languageId') + '=' + encodeURIComponent(state.languageId[i]))
      }
    }

    Object.entries(extra).forEach(([key, value]) => value instanceof Array ? value.forEach((val) => params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val))) : params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value)))
    params.push(encodeURIComponent('no_cache') + '=' + encodeURIComponent((new Date()).getTime()))
    return q + params.join('&')
  },
  getQueryExcluding: state => extra => {
    let i = 0
    let q = '?'
    let params = []
    let excluding = []
    Object.entries(extra).forEach(([key, value]) => key === 'exclude' ? (value instanceof Array ? value.forEach((val) => excluding.push(val)) : excluding.push(value)) : null)

    if (state.projectUuid && state.projectUuid.length > 0) {
      params.push(encodeURIComponent('projectUuid') + '=' + encodeURIComponent(state.projectUuid))
    }

    if (state.fromDate && isValid(parse(state.fromDate)) && excluding.indexOf('fromDate') === -1) {
      if (!Array.isArray(state.fromTime)) {
        var fromTimeArray = state.fromTime.split(':')
        params.push(encodeURIComponent('fromDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.fromDate, fromTimeArray[0], fromTimeArray[1], fromTimeArray[2])))
      } else {
        params.push(encodeURIComponent('fromDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.fromDate, 0, 0, 0)))
      }
    }

    if (state.toDate && isValid(parse(state.toDate)) && excluding.indexOf('toDate') === -1) {
      if (!Array.isArray(state.toTime)) {
        var toTimeArray = state.toTime.split(':')
        params.push(encodeURIComponent('toDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.toDate, toTimeArray[0], toTimeArray[1], toTimeArray[2])))
      } else {
        params.push(encodeURIComponent('toDate') + '=' + encodeURIComponent(getQueryFromDateTime(state.toDate, 23, 59, 59)))
      }
    }

    params.push(encodeURIComponent('isDetected') + '=' + encodeURIComponent(state.isDetected))

    if (state.countryId && state.countryId.length > 0 && excluding.indexOf('countryId') === -1) {
      for (i = 0; i < state.countryId.length; i++) {
        params.push(encodeURIComponent('countryId') + '=' + encodeURIComponent(state.countryId[i]))
      }
    }

    if (state.stateId && state.stateId.length > 0 && excluding.indexOf('stateId') === -1) {
      for (i = 0; i < state.stateId.length; i++) {
        params.push(encodeURIComponent('stateId') + '=' + encodeURIComponent(state.stateId[i]))
      }
    }

    if (state.cityId && state.cityId.length > 0 && excluding.indexOf('cityId') === -1) {
      for (i = 0; i < state.cityId.length; i++) {
        params.push(encodeURIComponent('cityId') + '=' + encodeURIComponent(state.cityId[i]))
      }
    }

    if (state.userId && state.userId.length > 0 && excluding.indexOf('userId') === -1) {
      for (i = 0; i < state.userId.length; i++) {
        params.push(encodeURIComponent('userId') + '=' + encodeURIComponent(state.userId[i]))
      }
    }

    if (state.hashtag && state.hashtag.length > 0 && excluding.indexOf('hashtag') === -1) {
      for (i = 0; i < state.hashtag.length; i++) {
        params.push(encodeURIComponent('hashtag') + '=' + encodeURIComponent(state.hashtag[i]))
      }
    }

    if (state.emoji && state.emoji.length > 0 && excluding.indexOf('emoji') === -1) {
      for (i = 0; i < state.emoji.length; i++) {
        params.push(encodeURIComponent('emoji') + '=' + encodeURIComponent(state.emoji[i]))
      }
    }

    if (state.tweetType && state.tweetType.length > 0 && excluding.indexOf('tweetType') === -1) {
      for (i = 0; i < state.tweetType.length; i++) {
        params.push(encodeURIComponent('tweetType') + '=' + encodeURIComponent(state.tweetType[i]))
      }
    }

    if (state.sentiment && state.sentiment.length > 0 && excluding.indexOf('sentiment') === -1) {
      for (i = 0; i < state.sentiment.length; i++) {
        params.push(encodeURIComponent('sentiment') + '=' + encodeURIComponent(state.sentiment[i]))
      }
    }

    if (state.entity && state.entity.length > 0 && excluding.indexOf('entity') === -1) {
      for (i = 0; i < state.entity.length; i++) {
        params.push(encodeURIComponent('entity') + '=' + encodeURIComponent(state.entity[i]))
      }
    }

    if (state.entityType && state.entityType.length > 0 && excluding.indexOf('entityType') === -1) {
      for (i = 0; i < state.entityType.length; i++) {
        params.push(encodeURIComponent('entityType') + '=' + encodeURIComponent(state.entityType[i]))
      }
    }

    if (state.topic && state.topic.length > 0 && excluding.indexOf('topic') === -1) {
      for (i = 0; i < state.topic.length; i++) {
        params.push(encodeURIComponent('topic') + '=' + encodeURIComponent(state.topic[i]))
      }
    }

    if (state.articleTopic && state.articleTopic.length > 0 && excluding.indexOf('articleTopic') === -1) {
      for (i = 0; i < state.articleTopic.length; i++) {
        params.push(encodeURIComponent('articleTopic') + '=' + encodeURIComponent(state.articleTopic[i]))
      }
    }

    if (state.tweetTopic && state.tweetTopic.length > 0 && excluding.indexOf('tweetTopic') === -1) {
      for (i = 0; i < state.tweetTopic.length; i++) {
        params.push(encodeURIComponent('tweetTopic') + '=' + encodeURIComponent(state.tweetTopic[i]))
      }
    }

    if (state.screenName && state.screenName.length > 0 && excluding.indexOf('screenName') === -1) {
      for (i = 0; i < state.screenName.length; i++) {
        params.push(encodeURIComponent('screenName') + '=' + encodeURIComponent(state.screenName[i]))
      }
    }

    if (state.text && state.text.length > 0 && excluding.indexOf('text') === -1) {
      for (i = 0; i < state.text.length; i++) {
        params.push(encodeURIComponent('text') + '=' + encodeURIComponent(state.text[i]))
      }
    }

    if (state.excludeTerm && state.excludeTerm.length > 0 && excluding.indexOf('excludeTerm') === -1) {
      for (i = 0; i < state.excludeTerm.length; i++) {
        params.push(encodeURIComponent('excludeTerm') + '=' + encodeURIComponent(state.excludeTerm[i]))
      }
    }

    if (state.domain && state.domain.length > 0 && excluding.indexOf('domain') === -1) {
      for (i = 0; i < state.domain.length; i++) {
        params.push(encodeURIComponent('domain') + '=' + encodeURIComponent(state.domain[i]))
      }
    }

    if (state.languageId && state.languageId.length > 0 && excluding.indexOf('languageId') === -1) {
      for (i = 0; i < state.languageId.length; i++) {
        params.push(encodeURIComponent('languageId') + '=' + encodeURIComponent(state.languageId[i]))
      }
    }

    Object.entries(extra).forEach(([key, value]) => key !== 'exclude' ? (value instanceof Array ? value.forEach((val) => params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val))) : params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value))) : null)
    params.push(encodeURIComponent('no_cache') + '=' + encodeURIComponent((new Date()).getTime()))
    return q + params.join('&')
  },
  getQueryInternal: state => extra => {
    let i = 0
    let q = '?'
    let params = []

    if (state.projectUuid && state.projectUuid.length > 0) {
      params.push(encodeURIComponent('projectUuid') + '=' + encodeURIComponent(state.projectUuid))
    }

    if (state.fromDate && isValid(parse(state.fromDate))) {
      params.push(encodeURIComponent('fromDate') + '=' + encodeURIComponent(state.fromDate))
    }

    if (state.toDate && isValid(parse(state.toDate))) {
      params.push(encodeURIComponent('toDate') + '=' + encodeURIComponent(state.toDate))
    }

    if (state.fromTime && !Array.isArray(state.fromTime)) {
      params.push(encodeURIComponent('fromTime') + '=' + encodeURIComponent(state.fromTime))
    }

    if (state.toTime && !Array.isArray(state.toTime)) {
      params.push(encodeURIComponent('toTime') + '=' + encodeURIComponent(state.toTime))
    }

    params.push(encodeURIComponent('isDetected') + '=' + encodeURIComponent(state.isDetected))

    if (state.countryId && state.countryId.length > 0) {
      for (i = 0; i < state.countryId.length; i++) {
        params.push(encodeURIComponent('countryId') + '=' + encodeURIComponent(state.countryId[i]))
      }
    }

    if (state.stateId && state.stateId.length > 0) {
      for (i = 0; i < state.stateId.length; i++) {
        params.push(encodeURIComponent('stateId') + '=' + encodeURIComponent(state.stateId[i]))
      }
    }

    if (state.cityId && state.cityId.length > 0) {
      for (i = 0; i < state.cityId.length; i++) {
        params.push(encodeURIComponent('cityId') + '=' + encodeURIComponent(state.cityId[i]))
      }
    }

    if (state.userId && state.userId.length > 0) {
      for (i = 0; i < state.userId.length; i++) {
        params.push(encodeURIComponent('userId') + '=' + encodeURIComponent(state.userId[i]))
      }
    }

    if (state.hashtag && state.hashtag.length > 0) {
      for (i = 0; i < state.hashtag.length; i++) {
        params.push(encodeURIComponent('hashtag') + '=' + encodeURIComponent(state.hashtag[i]))
      }
    }

    if (state.emoji && state.emoji.length > 0) {
      for (i = 0; i < state.emoji.length; i++) {
        params.push(encodeURIComponent('emoji') + '=' + encodeURIComponent(state.emoji[i]))
      }
    }

    if (state.tweetType && state.tweetType.length > 0) {
      for (i = 0; i < state.tweetType.length; i++) {
        params.push(encodeURIComponent('tweetType') + '=' + encodeURIComponent(state.tweetType[i]))
      }
    }

    if (state.sentiment && state.sentiment.length > 0) {
      for (i = 0; i < state.sentiment.length; i++) {
        params.push(encodeURIComponent('sentiment') + '=' + encodeURIComponent(state.sentiment[i]))
      }
    }

    if (state.entity && state.entity.length > 0) {
      for (i = 0; i < state.entity.length; i++) {
        params.push(encodeURIComponent('entity') + '=' + encodeURIComponent(state.entity[i]))
      }
    }

    if (state.entityType && state.entityType.length > 0) {
      for (i = 0; i < state.entityType.length; i++) {
        params.push(encodeURIComponent('entityType') + '=' + encodeURIComponent(state.entityType[i]))
      }
    }

    if (state.topic && state.topic.length > 0) {
      for (i = 0; i < state.topic.length; i++) {
        params.push(encodeURIComponent('topic') + '=' + encodeURIComponent(state.topic[i]))
      }
    }

    if (state.articleTopic && state.articleTopic.length > 0) {
      for (i = 0; i < state.articleTopic.length; i++) {
        params.push(encodeURIComponent('articleTopic') + '=' + encodeURIComponent(state.articleTopic[i]))
      }
    }

    if (state.tweetTopic && state.tweetTopic.length > 0) {
      for (i = 0; i < state.tweetTopic.length; i++) {
        params.push(encodeURIComponent('tweetTopic') + '=' + encodeURIComponent(state.tweetTopic[i]))
      }
    }

    if (state.screenName && state.screenName.length > 0) {
      for (i = 0; i < state.screenName.length; i++) {
        params.push(encodeURIComponent('screenName') + '=' + encodeURIComponent(state.screenName[i]))
      }
    }

    if (state.text && state.text.length > 0) {
      for (i = 0; i < state.text.length; i++) {
        params.push(encodeURIComponent('text') + '=' + encodeURIComponent(state.text[i]))
      }
    }

    if (state.excludeTerm && state.excludeTerm.length > 0) {
      for (i = 0; i < state.excludeTerm.length; i++) {
        params.push(encodeURIComponent('excludeTerm') + '=' + encodeURIComponent(state.excludeTerm[i]))
      }
    }

    if (state.domain && state.domain.length > 0) {
      for (i = 0; i < state.domain.length; i++) {
        params.push(encodeURIComponent('domain') + '=' + encodeURIComponent(state.domain[i]))
      }
    }

    if (state.languageId && state.languageId.length > 0) {
      for (i = 0; i < state.languageId.length; i++) {
        params.push(encodeURIComponent('languageId') + '=' + encodeURIComponent(state.languageId[i]))
      }
    }

    Object.entries(extra).forEach(([key, value]) => value instanceof Array ? value.forEach((val) => params.push(encodeURIComponent(key) + '=' + encodeURIComponent(val))) : params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value)))
    return q + params.join('&')
  },
  getDirty (state) {
    return state.dirty
  },
  getProjectUuid (state) {
    return state.projectUuid
  },
  getFromDate (state) {
    return state.fromDate
  },
  getToDate (state) {
    return state.toDate
  },
  getFromTime (state) {
    return state.fromTime
  },
  getToTime (state) {
    return state.toTime
  },
  getIsDetected (state) {
    return state.isDetected
  },
  getCountryId (state) {
    return state.countryId
  },
  getStateId (state) {
    return state.stateId
  },
  getCityId (state) {
    return state.cityId
  },
  getUserId (state) {
    return state.userId
  },
  getHashtag (state) {
    return state.hashtag
  },
  getEmoji (state) {
    return state.emoji
  },
  getTweetType (state) {
    return state.tweetType
  },
  getSentiment (state) {
    return state.sentiment
  },
  getEntity (state) {
    return state.entity
  },
  getEntityType (state) {
    return state.entityType
  },
  getTopic (state) {
    return state.topic
  },
  getArticleTopic (state) {
    return state.articleTopic
  },
  getTweetTopic (state) {
    return state.tweetTopic
  },
  getScreenName (state) {
    return state.screenName
  },
  getText (state) {
    return state.text
  },
  getExcludeTerm (state) {
    return state.excludeTerm
  },
  getDomain (state) {
    return state.domain
  },
  getLanguageId (state) {
    return state.languageId
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js